/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { Constants, AlertStatus, PERMISSIONS } from "../../../contants";
import { style } from "./TicketList.styles";
import Table from "../../../components/common/new/Table/Table";
import Toast from "../../../components/common/Toast";
import TicketingSystem from "../../../services/api/ticketingSystem";
import { performOperation } from "../../member/MemberSearch/utils";
import Loader from "../../../components/common/Loader/Loader";
import Typography from "../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import CreateTicketModal from "../CreateTicketModal/CreateTicketModal";
import useUserConfig from "../../../hooks/useUserConfig";
import { selectUserRole } from "../../../redux/selectors/user";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
import Button from "../../../components/common/Button";
import InputField from "../../../components/common/new/InputField/InputField";

function TicketList() {
  const [showToast, setShowToast] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("view");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const hasPermission = useUserConfig();
  const userRole = useSelector(selectUserRole);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [ticketId, setTicketId] = useState("");

  const STATUS_OPTIONS = [
    {
      key: "All",
      value: "",
    },
    {
      key: "Todo",
      value: "TO_DO",
    },
    {
      key: "In Progress",
      value: "IN_PROGRESS",
    },
    {
      key: "Done",
      value: "DONE",
    },
    {
      key: "Cancelled",
      value: "CANCELLED",
    },
  ];
  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };
  const fetchData = async (page = 0, size = Constants.DEFAULT_PAGE_SIZE) => {
    try {
      setIsLoading(true);
      const data = {
        page,
        size,
        status: "",
        ticketId: "",
      };
      const result = await TicketingSystem.getTicket({
        data,
      });
      setSearchData(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setSize(result.data.size);
      setIsLoading(false);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
      setIsLoading(false);
    }
  };

  const handleSearch = async (page = 0, size = Constants.DEFAULT_PAGE_SIZE) => {
    try {
      setIsLoading(true);
      const data = {
        page,
        size,
        status: selectedStatus,
        ticketId,
      };
      const result = await TicketingSystem.getTicket({
        data,
      });
      setSearchData(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setSize(result.data.size);
      setIsLoading(false);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
      setIsLoading(false);
    }
  };

  const onPaginationClick = (page) => {
    if (!selectedStatus) {
      fetchData(Number(page), size);
    } else {
      handleSearch(Number(page), size);
    }
    // fetchData(Number(page), size);
  };

  const onPageSizeClick = (operator) => {
    const newPageSize = performOperation(
      size,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    if (!selectedStatus) {
      fetchData(0, newPageSize);
    } else {
      handleSearch(0, newPageSize);
    }
    // fetchData(0, newPageSize);
  };

  const closeModal = () => {
    setModalOpen((prev) => !prev);
    setSelectedTicketId(null);
  };

  const onEditClick = (id) => {
    setModalMode("edit");
    setSelectedTicketId(id);
    setModalOpen(true);
  };

  const onRefresh = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);
  // Table Logic

  const COLUMNS = [
    {
      displayName: "TID",
      key: "tid",
    },
    {
      displayName: "Module",
      key: "module",
    },
    {
      displayName: "Subject",
      key: "subject",
    },
    userRole === "helpDesk" && {
      displayName: "Assignee",
      key: "assignee",
    },
    userRole === "helpDesk" && {
      displayName: "Priority",
      key: "priority",
    },
    {
      displayName: "Status",
      key: "status",
    },
    {
      displayName: "Created",
      key: "created",
    },
    {
      displayName: "Updated",
      key: "updated",
    },
    {
      displayName: "ACTION",
      key: "action",
    },
  ].filter(Boolean);
  const getRows = (data, onEditClick, hasPermission) =>
    data?.map((memberData) => (
      <TableRow>
        <TableCell style={style.rowStyle}>
          <Typography variant="small" color="#183053">
            {memberData.id}
          </Typography>{" "}
        </TableCell>
        <TableCell style={style.rowStyle}>
          <Typography variant="small" color="#183053">
            {memberData.moduleName}
          </Typography>{" "}
        </TableCell>
        <TableCell
          style={{
            ...style.rowStyle,
            maxWidth: "420px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          <Typography variant="small" color="#183053">
            {memberData.subject || "-"}
          </Typography>
        </TableCell>

        {userRole === "helpDesk" && (
          <TableCell style={style.rowStyle}>
            <Typography variant="small" color="#183053">
              {memberData.assigneeName || "-"}
            </Typography>
          </TableCell>
        )}
        {/* <TableCell style={{ ...style.rowStyle }}>
          <Typography variant="small" color="#183053">
            {memberData.reporterName || "-"}
          </Typography>
        </TableCell> */}
        {userRole === "helpDesk" && (
          <TableCell style={style.rowStyle}>
            <Typography variant="small" color="#183053">
              {memberData.priority}
            </Typography>
          </TableCell>
        )}
        <TableCell style={style.rowStyle}>
          <Typography variant="small" color="#183053">
            {memberData.status}
          </Typography>
        </TableCell>
        <TableCell style={style.rowStyle}>
          <Typography variant="small" color="#183053">
            {memberData.createdAt
              ? moment(memberData.createdAt).format("DD/MM/YYYY")
              : "-"}
          </Typography>
        </TableCell>
        <TableCell style={style.rowStyle}>
          <Typography variant="small" color="#183053">
            {memberData.updatedAt
              ? moment(memberData.updatedAt).format("DD/MM/YYYY")
              : "-"}
          </Typography>
        </TableCell>
        {/* <TableCell style={{ ...style.rowStyle }}>
          <Typography variant="small" color="#183053">
            {memberData.dueDate
              ? moment(memberData.dueDate).format("DD/MM/YYYY")
              : "-"}{" "}
          </Typography>
        </TableCell> */}
        <TableCell style={{ color: "rgba(140, 140, 140, 1)" }}>
          <Box style={style.flexC}>
            {hasPermission(PERMISSIONS.UPDATE_TICKET) && (
              <Tooltip title="Edit">
                <EditOutlinedIcon
                  style={style.icon}
                  onClick={() => onEditClick(memberData?.id)}
                />
              </Tooltip>
            )}
          </Box>
        </TableCell>
      </TableRow>
    ));
  return (
    <Box sx={style.container}>
      <Box sx={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        <Box sx={{ width: "20%" }}>
          <Dropdown
            sx={{ height: "41.1px" }}
            value={selectedStatus}
            options={STATUS_OPTIONS}
            label="Select Status"
            onChange={handleStatusChange}
          />
        </Box>
        <Box sx={{ width: "20%" }}>
          <InputField
            name="ticket_id"
            label="Ticket Id"
            value={ticketId}
            onChange={(e) => setTicketId(e.target.value)}
          />
        </Box>
        <Button
          variant="contained"
          label="Search"
          onClick={() => handleSearch()}
        />
      </Box>
      <Box style={style.tableContainer}>
        {searchData?.length ? (
          <>
            <Table
              scrollable
              columns={COLUMNS}
              rows={getRows(searchData, onEditClick, hasPermission)}
              columnCellStyle={{ textAlign: "left" }}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
              }}
            />
            <Box style={style.pagination}>
              <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={size}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </Box>
          </>
        ) : (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )}
      </Box>
      {isLoading && <Loader />}
      <CreateTicketModal
        open={modalOpen}
        onClose={closeModal}
        mode={modalMode}
        ticketId={selectedTicketId}
        onRefresh={onRefresh}
      />
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default TicketList;
